import React from 'react'
import { LoginPage as LoginPageComponent } from './pages/LoginPage'

const LoginPage: React.FC = () => {
  return <LoginPageComponent />
}

export default LoginPage 